// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"MusicHandler_contentContainer__3wIJV","icon":"MusicHandler_icon__26P-h","iconDark":"MusicHandler_iconDark__3HVHX"};